import React, { useEffect, useState } from 'react';
import { convertEpochToDateTime, GetAuctionList } from '../../../hooks/AuctionHook';
import AuctionDynamicNFTCard from './AuctionDynamicCard';
import NFTCardPlaceholder from '../NFTCardPlaceholder';
import { listNFTs } from '../../../hooks/NFTHook';

const CardAuctions = (props) => {
  const [auctions, setAuctions] = useState([]);
  const [nftLength, setNftLength] = useState(props.nftLength);
  const walletAddress = localStorage.getItem("WalletAddress");
  const [hasMore, setHasMore] = useState(true); // Flag for infinite scroll
  const [limit, setLimit] = useState(props.nftLength); // Items per page
  const userIds = localStorage.getItem("userId");

  useEffect(() => {
    GetAuctions();
  }, []);
  const GetAuctions = async () => {
    const params = { page: 1, limit, active: true, sortBy: "createdAt" }
    const { success, data, total, totalPages, page } = await GetAuctionList(params)
    if (success) {
      const collectionsWithMarketData = await Promise.all(
        data.map(async (collection) => {
          const marketData = await fetchMarketData(collection);
          console.log("marketData", marketData);
          const MarketNFTs = marketData.data;
          const AddIsLikeFlag = MarketNFTs.map(item => {
            const isLike = item.likes.some(like =>
              like.userId === userIds // Check if the user's ID exists in the likes array
            );

            return { ...item, isLike }; // Merge the `isLike` flag into the NFT object
          });
          const getEndTime = convertEpochToDateTime(collection.endTime / 2)
          console.log("AddIsLikeFlag", AddIsLikeFlag, getEndTime);
          return {
            ...collection,
            endTime: getEndTime,
            ...AddIsLikeFlag[0]
          };
        })
      );
      console.log("collectionsWithMarketData", collectionsWithMarketData);
      setAuctions(collectionsWithMarketData)
      setHasMore(total > 0)
    }
    else {
      setHasMore(false)
    }

  }
  const fetchMarketData = async (data) => {
    try {
      const params = {
        tokenId: data.tokenId,
        contractAddress: data.collectionAddress,
      };
      const response = await listNFTs(params);
      console.log("response", response, params);

      return response.success ? response : { success: false, data: [] };
    } catch (error) {
      console.error("Error fetching market data:", error);
      return { success: false, data: [] };
    }
  };
  return (
    <div className="row">
      {auctions.length !== 0 ? auctions.slice(0, nftLength).map((val, i) => (
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 card-hover-effect" key={i}>
          <AuctionDynamicNFTCard
            NFTLink={`/auction/details/${val.contractAddress}/${val.contractAddress}/${val.contractAddress}/${val.auctionId}`}
            currentOwnerPic={val?.currentOwner?.userId?.profilePicture}
            currentOwnerName={val?.currentOwner?.userId?.name}
            currentOwnerLink={val?.currentOwner?.walletAddress !== walletAddress ? `/otherProfile/${val?.currentOwner?.walletAddress}` : "/profile"}
            mediaUrl={val.imageUri} // Can be an image or video URL
            assetType={val.AssetType} // Pass true for video or false for image
            title={val.title}
            price={val.price}
            likes={val.totalLikes}
            isLiked={val.isLike}
            tokenId={val.tokenId}
            endTime={val.endTime}
            nftId={val._id}
          />
        </div>
      )) : (hasMore ?
        // Display skeleton loader while fetching data
        <>
          {[...Array(limit)].map((_, index) => (
            <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
              {/* <Skeleton height={300} /> */}
              <NFTCardPlaceholder />
            </div>
          ))}
        </> :
        <h3>
          No Auction Available
        </h3>
      )}
    </div>
  );
};

export default CardAuctions;